import { diplomaApi } from '../../utils/urls';
import { rootApi } from '../../services/rootApi';

export const diplomaApiSlice = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    checkDiplomaInfo: builder.query({
      query: ({ code }) => ({
        url: diplomaApi(),
        method: 'POST',
        body: {
          data: { code },
          method: 'validateUniqueCode'
        }
      }),
      transformResponse: (response) => response.data,
      providesTags: (result, error, { code }) => [
        { type: 'Diploma', id: code }
      ]
    }),

    getDiplomaList: builder.query({
      query: () => ({
        url: diplomaApi(),
        method: 'POST',
        body: {
          data: {},
          method: 'list'
        }
      }),
      transformResponse: (response) => response.data,
      providesTags: (result) => [
        { type: 'DiplomaList', id: 'LIST' },
        ...(result ?? []).map((diploma) => ({ type: 'Diploma', id: diploma.id })),
      ]
    }),

    downloadDiploma: builder.mutation({
      query: ({ courseId }) => ({
        url: diplomaApi(),
        method: 'POST',
        body: {
          data: { courseId },
          method: 'download'
        },
        // Prevent baseQuery from showing a generic error toast. We'll handle errors in the actions/UI layer.
        suppressGenericErrorToast: true,
      }),
      transformResponse: (response) => response.data,
      invalidatesTags: [{ type: 'Diploma', id: 'LIST' }]
    }),

    emailDiploma: builder.mutation({
      query: ({ courseId, recipientEmail }) => ({
        url: diplomaApi(),
        method: 'POST',
        body: {
          data: { courseId, recipientEmail },
          method: 'mail'
        },
        // Prevent baseQuery from showing a generic error toast. We'll handle errors in the actions/UI layer.
        suppressGenericErrorToast: true,
      }),
      transformResponse: (response) => response.data,
      invalidatesTags: [{ type: 'Diploma', id: 'LIST' }]
    })
  }),
  overrideExisting: false,
});

export const {
  useCheckDiplomaInfoQuery,
  useLazyCheckDiplomaInfoQuery,
  useGetDiplomaListQuery,
  useDownloadDiplomaMutation,
  useEmailDiplomaMutation,
} = diplomaApiSlice; 